var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"wrapper"}},[_c('animated-number',{attrs:{"value":_vm.value,"formatValue":_vm.theFormat,"duration":2000,"delay":_vm.delay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }